import {
    deleteOrganization,
    fetchOrganization,
    saveOrganization,
    updateOrganization,
} from '../reducers/recordsSlice';
import {recordSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../../hooks/useTypedReactRedux';
import {Organization} from '../types';

export const useOrganization = (organizationId?: string) => {


    const dispatch = useAppDispatch();

    const {
        record,
        loading,
    } = useAppSelector((state) =>
                           recordSelector(state, organizationId ? organizationId : ''),
    );

    // FETCH
    const fetchRecord = () => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }
        dispatch(fetchOrganization(organizationId));
    };

    // CREATE, UPDATE DELETE
    const createRecord = (values: Organization) => {
        dispatch(saveOrganization(values));
    };

    const updateRecord = (values: Organization) => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }

        dispatch(updateOrganization({
                                        id: organizationId,
                                        record: values,
                                    }));
    };

    const deleteRecord = () => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }
        dispatch(deleteOrganization(organizationId));
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
